export const bienvenue = require('./Bienvenue.png');
export const contact = require('./Contactez-nous.png');
export const endurence = require('./Endurance.png');
export const gym = require('./Gymnastique.png');
export const halterophilie = require('./Halterophilie.png');
export const accompagnement = require('./Accompagnement.png');
export const depassement_de_soi = require('./Dépassement de soi.png');
export const partage = require('./Partage.png');
